import { useState, useEffect } from 'react'
import api from '../components/api'
import Table from 'react-bootstrap/Table'


const Residuos_Indicadores = (props) => {


    const residuo_id = props.formulario_id

    const [resultadoGeracaoResiduos, setResultadoGeracaoResiduos] = useState()
    const [resultadoTratamento, setResultadoTratamento] = useState()

    
    const carregaGeracaoResiduos = () => {

        console.log(`residuosTabela/${residuo_id}`)

        api.get(`residuosTabela/${residuo_id}`).then((result) => {

            //console.log(result.data)
            setResultadoGeracaoResiduos(result.data.map((rs) =>

                    <tr >

                        <td>
                            {rs.grupoResiduo_descri}
                        </td>
                        <td style={{ textAlign: 'right'}}>
                            {rs.totalResiduos ? rs.totalResiduos.toLocaleString('pt-BR') : ''}
                        </td>
                        <td style={{ textAlign: 'right'}}>
                            {rs.porcentagem ? rs.porcentagem.toLocaleString('pt-BR') : ''}
                        </td>
                        <td style={{ textAlign: 'right'}}>
                            {rs.totalFte ? rs.totalFte.toLocaleString('pt-BR') : ''}
                        </td>
                        <td style={{ textAlign: 'right'}}>
                            {rs.totalm2 ? rs.totalm2.toLocaleString('pt-BR') : ''}
                        </td>
                        <td style={{ textAlign: 'right'}}>
                            {rs.totalLeitos ? rs.totalLeitos.toLocaleString('pt-BR') : ''}
                        </td>
                        

                    </tr>

                    
        
            ))

        }).catch((err) => {

            console.log(err)

        })

    }


    const carregaTratamento = () => {

        

        api.get(`tabelaTipoTratamento/${residuo_id}`).then((result) => {

            //console.log(result.data)
            setResultadoTratamento(result.data.map((rs) => {

                if (rs.tipo) {
                
                    return (

                        <tr >

                            <td>
                                <center>
                                {rs.tipo}
                                </center>
                            </td>
                            <td style={{ textAlign: 'left'}}>
                                {rs.tipoTratamento_descri}
                            </td>
                            <td style={{ textAlign: 'right'}}>
                                {rs.totalResiduos ? rs.totalResiduos.toLocaleString('pt-BR') : ''}
                            </td>
                            <td style={{ textAlign: 'right'}}>
                                {rs.porcentagem ? rs.porcentagem.toLocaleString('pt-BR') : ''}
                            </td>                    

                        </tr>

                    )
            
                } else {

                    return (

                        <tr>
                            <th colSpan={2} style={{ textAlign: 'center'}}>

                                Total

                            </th>
                            <th style={{ textAlign: 'right'}}>
                                {rs.totalGeral ? rs.totalGeral.toLocaleString('pt-BR') : ''}
                            </th>
                            <th style={{ textAlign: 'right'}}>
                                {rs.porcentagemTotal ? rs.porcentagemTotal.toLocaleString('pt-BR') : ''}
                            </th>  

                        </tr>

                    )

                }

            }
                
        
            ))

        }).catch((err) => {

            console.log(err)

        })

    }



    useEffect(() => {

        carregaGeracaoResiduos()
        carregaTratamento()

    }, [residuo_id])


    return (

        <div>

                <div className="col-md-12" >


                    <Table striped bordered hover >

                        <thead>
                            <tr >
                                <th style={{ backgroundColor: '#304d37', color: '#FFF'}}>
                                    <center>
                                    Tipos de Resíduos
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#304d37', color: '#FFF'}}>
                                    <center>
                                    Total de resíduos por Grupo (kg) 
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#304d37', color: '#FFF'}}>
                                    <center>
                                    % de resíduos por Grupo 
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#304d37', color: '#FFF'}}>
                                    <center>
                                    Kg/FTE
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#304d37', color: '#FFF'}}>
                                    <center>
                                    Kg/m<sup>2</sup>
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#304d37', color: '#FFF'}}>
                                    <center>
                                    Kg/leito ocupado
                                    </center>
                                </th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            {resultadoGeracaoResiduos}
                        </tbody>
                    </Table>

                </div>

                <div className="col-md-12" >

                    

                    <Table striped bordered hover >

                        <thead>
                            <tr >
                                <th colSpan={2} style={{ backgroundColor: '#7d466f', color: '#FFF'}}>
                                    <center>
                                    Tipos de tratamento e destinação
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#7d466f', color: '#FFF'}}>
                                    <center>
                                    Subtotal por [Tipo de Tratamento/Destinação]
                                    </center>
                                </th>
                                <th style={{ backgroundColor: '#7d466f', color: '#FFF'}}>
                                    <center>
                                    % em relação ao total geral
                                    </center>
                                </th>
                                
                                
                            </tr>
                        </thead>
                        <tbody>
                            {resultadoTratamento}
                        </tbody>
                    </Table>

                </div>

                

        </div>

    )

}


export default Residuos_Indicadores